// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import { string } from 'prop-types'
import columns from './columns'

const HeadingRow = ({ idRoot }) => (
  <tr>
    <td />
    {
      columns.map(d => (
        <th key={d.columnKey}>
          {d.columnHeader}
        </th>
      ))
    }
  </tr>
)

HeadingRow.propTypes = {
  idRoot: string.isRequired,
}

export default HeadingRow
